import { Component, Input, Output, EventEmitter } from '@angular/core';
import { QuestionBase } from '@app/core/models/question/question-base';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html'
})
export class RadioComponent {
  @Input() form: FormGroup;
  @Input() question: QuestionBase<any>;
  @Output() selected = new EventEmitter<boolean>();
  allowChecked = true;

  check(value1, value2) {
    return Number(value1) === Number(value2);
  }

  handleClick(event, key) {
    let value;
    if (!this.form.value[key]) {
      this.allowChecked = true;
      value = event.target.value;
    } else {
      if (Number(event.target.value) === Number(this.form.value[key])) {
        this.allowChecked = false;
        value = '';
      } else if (Number(event.target.value) !== Number(this.form.value[key])) {
        this.allowChecked = true;
        value = event.target.value;
      }
    }

    this.form.controls[key].setValue(value);
    this.selected.emit(true);
    this.form.updateValueAndValidity();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/radio/radio.component.ts